import { getItemFromS3 } from "../../common/Utilities";

export const getBase64ImageFromS3 = async (fileName, bucket) => {
  const data = await getItemFromS3(bucket, fileName, false);
  const fileExtension = fileName.substring(fileName.lastIndexOf(".") + 1);
  const buffer = Buffer.from(data.Body);
  const base64Image = buffer.toString("base64");
  return `data:image/${fileExtension};base64,${base64Image}`;
};
